"use client"

import { useEffect, useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"
import API_BASE_URL from "./Config"
import { formatDistanceToNow } from 'date-fns';


const SearchHistory = () => {
    const [searchHistory, setSearchHistory] = useState([])
    const [topSearches, setTopSearches] = useState([])


  useEffect(() => {
    fetch(API_BASE_URL + "getSearch",{
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
    }).then(response=>response.json())
    .then((data)=>{
        if (data.success) {
            const formattedSearches = data.search
              .map((search) => ({
                ...search,
                formattedTimestamp: formatDistanceToNow(new Date(search.timestamp), { addSuffix: true }),
              }))
              .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)); 
            setSearchHistory(formattedSearches);
            setTopSearches(data.search.sort((a,b)=>(b.searchCount) - (a.searchCount))); 
    
          }
        }).catch((error) => console.error("Error fetching search history:", error));

  },[]);

  return (

        <div className="card-body p-0">
          <div className="row g-0">
            {/* Recent Searches Section */}
            <div className="col-md-6" style={{ borderRight: "1px solid rgba(0,0,0,0.08)" }}>
              <div className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="card-title mb-0 fw-semibold text-dark">
                    <i className="bi bi-clock-history me-2 text-primary"></i>
                    Recent Searches
                  </h5>
                </div>

                {searchHistory.length > 0 ? (
                  <div className="list-group list-group-flush" style={{ maxHeight: "350px", overflowY: "auto" }}>
                    {searchHistory?.map((search) => (
                      <button
                        key={search.searchId}
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center p-3 border-0 mb-1 rounded-3 transition"

                        style={{
                          backgroundColor: "rgba(13, 110, 253, 0.04)",
                          transition: "all 0.2s ease",
                          cursor: "pointer",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "rgba(13, 110, 253, 0.08)")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "rgba(13, 110, 253, 0.04)")}
                      >
                        <span className="fw-medium text-dark">
                      
                          {search.searchterm}
                        </span>
                        <small className="text-muted bg-light px-2 py-1 rounded-pill">
                          <i className="bi bi-clock me-1"></i>
                          {search.formattedTimestamp}
                        </small>
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4 text-muted">
                    <i className="bi bi-search display-6 mb-2 d-block opacity-50"></i>
                    <p>No recent searches</p>
                  </div>
                )}

                
              </div>
            </div>

            <div className="col-md-6" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="p-4">
                <h5 className="card-title mb-3 fw-semibold text-dark">
                  <i className="bi bi-graph-up-arrow me-2 text-success"></i>
                  Top Searches
                </h5>
                
                <div className="top-searches-container" style={{ maxHeight: "350px", overflowY: "auto" }}>
                    {topSearches?.map((search, index) => (
                       <div
                       key={search.searchId}
                       className="d-flex align-items-center p-3 mb-2 rounded-3 transition"
                       style={{
                         cursor: "pointer",
                         backgroundColor: "white",
                         boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                         transition: "all 0.2s ease",
                       }}
                       onMouseOver={(e) => {
                         e.currentTarget.style.backgroundColor = "white"
                         e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.08)"
                       }}
                       onMouseOut={(e) => {
                         e.currentTarget.style.backgroundColor = "white"
                         e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.04)"
                       }}
                     >
                         <div className="position-relative me-3">
                        <span
                          className="position-absolute top-50 start-50 translate-middle fw-bold"
                          style={{ fontSize: "14px", color: "#6c757d" }}
                        >
                          {index + 1}
                        </span>
                        <div
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(13, 110, 253, 0.1)",
                            border: "2px solid rgba(13, 110, 253, 0.2)",
                          }}
                        ></div>
                      </div>
                      <div className="flex-grow-1">
                        <div className="fw-medium text-dark">{search.searchterm}</div>
                        <div className="d-flex align-items-center mt-1">
                          <small className="text-muted me-2">
                            <i className="bi bi-people-fill me-1"></i>
                            {search.searchCount} search{search.searchCount > 1 ? "es" : ""}
                          </small>
                        </div>
                      </div>
                      <div className="ms-2">
                        <i className="bi bi-chevron-right text-primary"></i>
                      </div>
                    </div>

                    ))}
                  </div>
                                
              </div>
            </div>

          </div>
        </div>

  )
}

export default SearchHistory
